import { render, staticRenderFns } from "./simpleText.vue?vue&type=template&id=51aee2cb&"
import script from "./simpleText.vue?vue&type=script&lang=js&"
export * from "./simpleText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../whitelabel/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports